import React from 'react';
import { Box, FiservCardInterface } from '@common-fe/common-fe';

import { CardItemActions } from '../../Cards/components/CardItemActions';
import { StyledActionsCarousel } from '../CardCarousel/CardCarousel.styles';

interface Props {
  cards: FiservCardInterface[];
  isLoading?: boolean;
  selectedItemIndex: number;
  isDarkMode?: boolean;
}

interface CardActionProps {
  card: FiservCardInterface;
  isLoading: boolean;
  selectedItemIndex: number;
  index: number;
  isDarkMode?: boolean;
}

const CardAction: React.FC<CardActionProps> = ({ card, index, isLoading, selectedItemIndex, isDarkMode }) => {
  if (isDarkMode) {
    return (
      <Box justify="center" data-testid={`CardActionsCarousel-item-${card.id}`}>
        {selectedItemIndex === index && <CardItemActions card={card} isDarkMode />}
      </Box>
    );
  }
  // TODO: will be removed soon
  return (
    <Box justify="center" height="60px" pad={{ horizontal: 'm' }}>
      <Box pad="spacing8" width={{ max: '458px' }}>
        {selectedItemIndex === index && (
          <Box data-testid={`CardActionsCarousel-item-${card.id}`}>
            <CardItemActions card={card} isLoading={isLoading} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export const CardActionsCarousel: React.FC<Props> = ({
  cards,
  isDarkMode,
  isLoading = false,
  selectedItemIndex,
}) => {
  if (isDarkMode) {
    return (
      <Box fill>
        {...cards.map((card, index) => (
          <CardAction
            card={card}
            isDarkMode
            key={card.id}
            index={index}
            selectedItemIndex={selectedItemIndex}
            isLoading={isLoading}
          />
        ))}
      </Box>
    );
  }
  // TODO: Will be removed soon
  return (
    <Box margin={{ right: '-8px', left: 'spacing8', bottom: 'spacing24' }}>
      <StyledActionsCarousel
        centerMode
        centerSlidePercentage={45}
        renderArrowNext={() => null}
        renderArrowPrev={() => null}
        showIndicators={false}
        showStatus={false}
        selectedItem={selectedItemIndex}
        showThumbs={false}
      >
        {[
          ...cards.map((card, index) => (
            <CardAction
              card={card}
              key={card.id}
              index={index}
              selectedItemIndex={selectedItemIndex}
              isLoading={isLoading}
            />
          )),
          <Box key="empty" />,
        ]}
      </StyledActionsCarousel>
    </Box>
  );
};
